import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import clockAnim from "../Assets/clock.json"; // 👈 adjust path if needed

function Pre({ load }) {
  const container = useRef(null);

  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: clockAnim,
    });

    return () => anim.destroy(); // cleanup when unmounted
  }, []);

  return (
    <div
      id={load ? "preloader" : "preloader-none"}
      className="preloader"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        inset: 0,
        backgroundColor: "#0a0a0a",
        zIndex: 9999,
      }}
    >
      <div ref={container} style={{ width: 250, height: 250 }} />
    </div>
  );
}

export default Pre;
